import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "axios";
import './../../Style/InsertRent.scss'
import { deleteAlert, errorAlert, updateAlert } from "../../Components/Alerts";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import LoginUserDetailed from '../../Auth/LoginUserDetailed';
import jwtDecode from "jwt-decode";
import { AiFillAppstore } from "react-icons/ai";
import { Paper } from "@mui/material";
import "jspdf-autotable";
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import './../../Style/TableStyle.scss'
import { Month } from "../../OtherData/Month";
import { MdEdit } from "react-icons/md";
import InsertTenants from "../Tenants/InsertTenants";
import { RentGridHeader } from "./RentGridHeader";
import DataGridWithActions from "../../Components/DataGridWithActions";
import Autocomplete from "@mui/material/Autocomplete";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import { ElementsParagraph, TitleElements } from "../../Components/HeadersCRUD-s";
import { AddLinkButton, LinkAndClickButton } from "../../Components/AddElementsButton";
import { HeaderPaperComponent } from "../../Components/HeaderPaperComponent";
import EditOfficialRent from "./EditOfficialRent";
import CancelModal from "../../Components/CancelModal";
import TotalSummaryComponent from "../../Components/TotalSummaryComponent";

export default function Rent() {
    const TranscationData = [
        {
            id: 1,
            type: "Vendor"
        },
        {
            id: 2,
            type: "Ndërkombëtar"
        },
    ]
    const [showDetails, setShowDetails] = useState(true);
    const { fiscalYear } = useContext(FiscalYearContext);
    const [selectedItem, setSelectedItem] = useState(null);
    const [changeButton, setChangeButton] = useState(false)
    const [showModal, setShowModal] = useState(false);

    const [minDate, setMinDate] = useState('');
    const [maxDate, setMaxDate] = useState('');

    useEffect(() => {
        setMinDate(`${fiscalYear}-01-01`);
        setMaxDate(`${fiscalYear}-12-31`);
    }, [fiscalYear])
    const loginEmail = LoginUserDetailed();
    const headers = authHeader();

    const [logedEmail, setLogedEmail] = useState("");

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            const decodedToken = jwtDecode(token);
            setLogedEmail(decodedToken.email);
        }
    }, []);

    const [data, setData] = useState([]);
    const [formData, setFormData] = useState({
        TransactionID: "",
        InvoiceNr: "",
        Date: "",
        PayDate: "",
        ActionType: "",
        AccountID: "",
        Amount8: 0,
        PaymentOptions: "",
        TransactionType: "",
        Comment: "",
        ModifiedByUser: "",
        CompanyUnitID: "",
    });

    const [showEditModal, setShowEditModal] = useState(false);
    const [showEditOfficialRent, setShowEditOfficialRent] = useState(false);
    const [tenants, setTenants] = useState([]);
    const [cashRegister, setCashRegister] = useState([]);

    const fetchData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Rent', { headers, params: { fiscalYear: fiscalYear } });
            setData(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
                console.error("Request Error: ", error);

            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
                console.error("Request Error: ", error);

            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
                console.error("Request Error: ", error);

            }
        }
    };

    // Kodi per fshirjen e nje elementi ne databaz 
    const handleDelete = async (deleteItemId) => {
        try {
            // const response = 
            await axios.delete(
                ApiLink.API_URL + 'rent' + `/${deleteItemId}`, { headers }
            );
            deleteAlert("Rent Deleted Successfully");
            fetchData();
        } catch (error) {
            deleteAlert("Rent can not be deleted");
        }
    };

    // Kodi per shfaqjen e formes per editimin e te dhenave ne databaz 
    const handleEdit = (item) => {
        setSelectedItem(item);
        setFormData({
            TransactionID: item.TransactionID,
            InvoiceNr: item.InvoiceNr,
            Date: item.Date,
            PayDate: item.PayDate,
            ActionType: item.ActionType,
            AccountID: item.AccountID,
            Amount8: item.QirajaNeto,
            PaymentOptions: item.PaymentOptions,
            TransactionType: item.TransactionType,
            Comment: item.Comment,
            ModifiedByUser: loginEmail,
            CompanyUnitID: item.CompanyUnitID,
        });
        if (item.ActionType === "RNE") {
            setShowEditOfficialRent(true);
        }
        else {
            setShowEditModal(true);
            calculateBruto(item.QirajaNeto);
        }
        setShowDetails(false);
    };

    // Kodi per ruajtjen e te dhenave pas editimint 
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
        setChangeButton(true);

    };
    //Dergimi i kerkeses per editimin e te dhenave ne backend 
    const handleSubmit = (event) => {
        event.preventDefault();
        axios
            .put(ApiLink.API_URL + 'rent', formData, { headers })
            .then((response) => {
                setShowEditModal(false); // Close the edit modal
                fetchData();
                setShowDetails(true);
                updateAlert("Qeraja nga personi fizik u ndryshua me sukses");
                setChangeButton(false);

            })
            .catch((error) => {
                // alert("Failed to update State");
                errorAlert("Failed to update Rent")
            });
    };

    useEffect(() => {
        axios.get(ApiLink.API_URL + 'Accounts/paymenttype', { headers, params: { email: logedEmail } })
            .then((response) => {
                setCashRegister(response.data);
            }).catch((error) => {
                // errorAlert(error);
            })
    }, [logedEmail])

    const fetchTenants = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Accounts/accountByLedger', { headers, params: { ledger: 308 } });
            setTenants(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const [qirajaBruto, setQirajaBruto] = useState(0);
    const [tatimiNeQira, setTatimiNeQira] = useState(0);

    const calculateNeto = async (brutoValue) => {
        try {
            const tatimiNeQira = Number(brutoValue) * (Number(9) / Number(100));
            const qirajaNeto = Number(brutoValue) - Number(tatimiNeQira);

            setFormData(prevState => ({
                ...prevState,
                Amount8: qirajaNeto
            }));
            setTatimiNeQira(tatimiNeQira);
        } catch (error) {
            console.error("Error during calculation:", error);
            // Perform any necessary error handling here
        }
    };

    const calculateBruto = async (netoValue) => {
        try {
            const brutoRent = Number(netoValue) / Number(0.91);
            const tatimiNeQira = Number(brutoRent) - Number(netoValue);

            setQirajaBruto(brutoRent);
            setTatimiNeQira(tatimiNeQira);
        } catch (error) {
            console.error("Error during calculation:", error);
            // Perform any necessary error handling here
        }
    };

    const calculateFromTatimi = async (tatimivalue) => {
        try {
            const brutoRent = (Number(tatimivalue) / Number(9)) * Number(100);
            const qirajaNeto = Number(brutoRent) - Number(tatimivalue);

            setFormData(prevState => ({
                ...prevState,
                Amount8: qirajaNeto
            }));
            setQirajaBruto(brutoRent);
        } catch (error) {
            console.error("Error during calculation:", error);
            // Perform any necessary error handling here
        }
    };

    const netoAmount = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.QirajaNeto), 0);
    }, [data]);

    const tatimiTotal = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.TatimiNeQira), 0);
    }, [data]);

    const brutoTotal = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.VleraPaTVSH_QirajaBruto), 0);
    }, [data]);

    const vatTotal = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.TVSH), 0);
    }, [data]);

    const vleraMeTvshTotal = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.VleraMeTVSH), 0);
    }, [data]);

    const perPagesTotal = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.PerPagese), 0);
    }, [data]);


    const rows = data.map((item, index) => ({
        id: ++index,
        month: item.InvoiceNr,
        date: (item.Date.substring(0, 10)),
        accname: item.AccountName,
        neto: item.QirajaNeto,
        tatimi: item.TatimiNeQira,
        bruto: item.VleraPaTVSH_QirajaBruto,
        tvsh: item.TVSH,
        valuewithVAT: item.VleraMeTVSH,
        pay: item.PerPagese,
        deleteItemId: item.TransactionID,
        rowInfo: item
    }));


    //Select list for tenant
    const handleAutocompleteChangeTenant = (event, value) => {
        if (value) {
            setFormData(prevState => ({
                ...prevState,
                AccountID: value.AccountID
            }));
            setChangeButton(true);

        } else {
            setFormData(prevState => ({
                ...prevState,
                AccountID: ""
            }));
        }
    };

    const defaultPropsTenant = {
        options: tenants,
        getOptionLabel: (option) =>
            `${option.IdentificationNumber} - ${option.AccountName}` || "",
        renderOption: (props, option) => (
            <>
                <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
                    <span>
                        {option.IdentificationNumber}<br />
                        {option.AccountName}
                    </span>
                    {/* <button
                        onClick={(e) => {
                            e.stopPropagation();
                            // handleButtonClick(option);
                        }}
                        onMouseEnter={handleOpen}
                        onMouseLeave={handleClose}
                        style={{ marginLeft: 'auto' }}
                    >
                        Click
                    </button> */}
                </li>
            </>
        ),
    };
    ////
    const handleCloseEditOfficialRent = () => {
        setShowEditOfficialRent(false);
        setShowDetails(true);
        fetchData();
    };
    const handleConfirm = () => {
        setShowModal(false);
        setChangeButton(false);
        setShowEditModal(false);
        setShowDetails(true);
    };

    useEffect(() => {
        fetchData();
        // fetchCompaniesData();
        fetchTenants();
    }, [logedEmail, fiscalYear]);

    return (
        <div className="Rent__Container">
            <CancelModal
                open={showModal}
                onClose={() => setShowModal(false)}
                title="Konfirmim"
                description="Jeni të sigurt që dëshironi të anuloni ndryshimet?"
                confirmText="po"     // Custom confirm button text
                cancelText="jo"      // Custom cancel button text
                onConfirm={() => handleConfirm()}
            />
            {/* Shfaqja  e modalit per editimin e te dhenave  */}
            {showEditOfficialRent && (
                <EditOfficialRent
                    item={selectedItem}
                    onClose={handleCloseEditOfficialRent}
                />)
            }
            {showEditModal && (
                <div className="edit">

                    <TitleElements
                        icon={MdEdit}
                        title="Ndyshimi Qirasë"
                    />
                    <hr></hr>
                    <div className="Rent__Container__AllButtons">
                        <div style={{ display: "flex", }}>
                            <InsertTenants fetchData={fetchTenants} type="insert" />
                        </div>
                        < div style={{ display: "flex" }}>
                            {changeButton ? (
                                <>
                                    <div style={{ marginLeft: "5px" }}>
                                        <LinkAndClickButton
                                            text="Ruaj"
                                            link="#"
                                            onClick={handleSubmit}
                                        />
                                    </div>
                                    <div style={{ marginLeft: "5px" }}>
                                        <LinkAndClickButton
                                            text="Anulo"
                                            link="#"
                                            onClick={() => {
                                                setShowModal(true);
                                            }}
                                        />
                                    </div>
                                </>
                            ) : (
                                <div style={{ marginLeft: "5px" }}>
                                    <LinkAndClickButton
                                        text="Mbyll"
                                        link="#"
                                        onClick={() => {
                                            setShowDetails(true);
                                            setShowEditModal(false);
                                            setChangeButton(false);
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <HeaderPaperComponent />
                    <form className='Rent__Container__Format'>
                        <Paper>
                            <Box
                                component="form"
                                sx={{
                                    '& .MuiTextField-root': { m: 1.3, width: '41ch' },
                                }}
                                noValidate
                                autoComplete="off"
                            >
                                <div className='Forma1'>
                                    <div className='Boxx'>
                                        <TextField
                                            className="AddPurchaseTotal__Container__Format__SameInput"
                                            // style={{ width: "594px" }}
                                            id="InvoiceNr"
                                            select
                                            name="InvoiceNr"
                                            label="Muaji"
                                            value={formData.InvoiceNr}
                                            onChange={handleInputChange}
                                        >
                                            {Month.map((data) => (
                                                <MenuItem key={data.id} value={fiscalYear + data.month}>{fiscalYear}{data.month}
                                                </MenuItem>
                                            ))}
                                        </TextField>

                                        <div className='AddPurchaseTotal__Container__Format__Dates'>
                                            <TextField
                                                className="AddPurchaseTotal__Container__Format__Date"
                                                id="Date"
                                                type="date"
                                                variant="outlined"
                                                name='Date'
                                                label='Data'
                                                value={formData.Date && formData.Date.substring(0, 10)}
                                                onChange={handleInputChange}
                                                inputProps={{
                                                    min: minDate, // Kufizimi minimal i datës
                                                    max: maxDate, // Kufizimi maksimal i datës
                                                }}
                                            />

                                            <TextField
                                                className="AddPurchaseTotal__Container__Format__Date"
                                                id="PayDate"
                                                type="date"
                                                variant="outlined"
                                                name='PayDate'
                                                label="Data pagesës"
                                                value={formData.PayDate && formData.PayDate.substring(0, 10)}
                                                onChange={handleInputChange}
                                            />
                                        </div>

                                        <div className="textfield_button">
                                            <Autocomplete
                                                fullWidth
                                                // sx={{ m: 2 }}
                                                {...defaultPropsTenant}
                                                id="AccountID"
                                                includeInputInList
                                                onChange={handleAutocompleteChangeTenant}
                                                renderInput={(params) => (
                                                    <TextField {...params}
                                                        label="Qiradhënësi"
                                                        // variant="filled"
                                                        className="AddPurchaseTotal__Container__Format__SameInput"
                                                    />
                                                )}
                                                ListboxProps={{
                                                    style: {
                                                        maxHeight: '200px', // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                                                        overflow: 'auto',   // Aktivizoni scroll-in për pjesën tjetër
                                                    },
                                                }}
                                                value={tenants.find(option => option.AccountID === formData.AccountID) || null}
                                            />
                                        </div>
                                        <div className="AddPurchaseTotal__Container__Format__Dates" style={{ paddingTop: "10px" }}>
                                            <TextField
                                                // style={{ width: "593px" }}
                                                className="AddPurchaseTotal__Container__Format__Date"
                                                id="AccountID"
                                                label="Llogaria Kontabel"
                                                defaultValue=""
                                                value={"308-Qiraja e Pagueshme"}
                                                // onChange={event => setAccountID(703)}
                                                disabled
                                            >
                                            </TextField>

                                            <TextField
                                                // style={{ width: "343px" }}
                                                className="AddPurchaseTotal__Container__Format__Date"
                                                id="id"
                                                select
                                                name="TransactionType"
                                                label="Lloji qirasë"
                                                value={formData.TransactionType}
                                                onChange={handleInputChange}
                                            >
                                                {TranscationData.map((data) => (
                                                    <MenuItem key={data.id} value={data.id}>{data.type}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </div>
                                        <TextField
                                            // style={{ width: "593px" }}
                                            className="AddPurchaseTotal__Container__Format__SameInput"
                                            id="id"
                                            select
                                            label="Mënyra pagesës"
                                            name="PaymentOptions"
                                            value={formData.PaymentOptions}
                                            onChange={handleInputChange}
                                        >
                                            <MenuItem key="0" value="0">Pagesa Behet më vonë
                                            </MenuItem>
                                            {cashRegister.map((data) => (
                                                <MenuItem key={data.AccountID} value={data.AccountID}>{data.AccountName}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </div>

                                    <div className='box2'>
                                        <TextField
                                            // style={{ width: "150px" }}
                                            className="AddPurchaseTotal__Container__Format__Comment"
                                            id="Amount8"
                                            label="Qiraja Neto"
                                            variant="outlined"
                                            name='Amount8'
                                            value={formData.Amount8 !== null && formData.Amount8 !== 0 ? formData.Amount8.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00'}
                                            onChange={handleInputChange}
                                            // onChange={event => setNetoRent(event.target.value)}
                                            onKeyUp={event => calculateBruto(event.target.value)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }} />
                                        <TextField
                                            // style={{ width: "150px" }}
                                            className="AddPurchaseTotal__Container__Format__Comment"
                                            id="outlined-basic"
                                            label="Tatimi në qira 9%"
                                            name='Amount18'
                                            variant="outlined"
                                            value={tatimiNeQira !== null && tatimiNeQira !== 0 ? tatimiNeQira.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00'}
                                            onChange={event => setTatimiNeQira(event.target.value)}
                                            onKeyUp={event => calculateFromTatimi(event.target.value)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        <TextField
                                            // style={{ width: "150px" }}
                                            className="AddPurchaseTotal__Container__Format__Comment"
                                            id="outlined-basic"
                                            label="Qiraja Bruto"
                                            variant="outlined"
                                            name='Total'
                                            value={qirajaBruto !== null && qirajaBruto !== 0 ? qirajaBruto.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00'}
                                            onChange={event => setQirajaBruto(event.target.value)}
                                            onKeyUp={event => calculateNeto(event.target.value)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        <TextField
                                            // style={{ width: "495px" }}
                                            className="AddPurchaseTotal__Container__Format__Comment"
                                            type="text"
                                            id="Coment"
                                            name="Coment"
                                            label="Komenti"
                                            variant="outlined"
                                            value={formData.Comment}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                            </Box>
                        </Paper>
                    </form>
                </div>
            )}
            {showDetails && (
                <div className="shfaqePermbajtjen">
                    <div className="header_flex">
                        <TitleElements
                            icon={AiFillAppstore}
                            title="Lista e Qirasë"
                        />
                        <div className="Rent__Header__Button" >
                            <AddLinkButton
                                text="Krijo një qira nga personi juridik "
                                icon="bi bi-plus-circle"
                                link="/expences/officialRent"
                            />
                            <AddLinkButton
                                text="Krijo një qira nga personi fizik"
                                icon="bi bi-plus-circle"
                                link="/expences/AddRent"
                            />
                        </div>
                    </div>
                    <ElementsParagraph text="Forma e Qirasë: Menaxhoni, shtoni, editoni dhe fshini Transaksione të Qirasë." />
                    <DataGridWithActions
                        columns={RentGridHeader}
                        rows={rows}
                        handleEdit={handleEdit}
                        handleDelete={handleDelete}
                        showPayment={true}
                        height={500}
                    />


                    <TotalSummaryComponent
                        fields={[
                            { id: '1', label: 'Qiraja Neto Total', value: netoAmount },
                            { id: '2', label: 'Tatimi Ne Qira Total', value: tatimiTotal },
                            { id: '3', label: 'Vlera Pa TVSH/Qiraja Bruto Total', value: brutoTotal },
                            { id: '4', label: 'TVSH Total', value: vatTotal },
                            { id: '5', label: 'Vlera Me TVSH Total', value: vleraMeTvshTotal },
                            { id: '6', label: 'PerPagese Total', value: perPagesTotal },
                        ]}
                    />

                </div>
            )}
        </div>
    )
}